import React, { useEffect, useState } from 'react'
import { getAllNonShippingOrder, getOutgingsNonShippingWithPage } from "../../../services/serviceWarehouseOutgoing";
import { Table } from "antd";
import TagsType from "../TagsType";
import TagsStatus from "../TagsStatus";
import userDateFormatter from "../../../services/formatters/userDateFormatter";
import OutgoingActions from "./OutgoingActions";
import { useLocation, navigate } from "@reach/router";

const OutgoingTab = ({ updateComponent }) => {
    const location = useLocation();
    const [sortedList, setSortedList] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getNonShippingsData(page, pageSize);
    }, [location.search, updateComponent]);

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const getNonShippingsData = (page, pageSize) => {
        getOutgingsNonShippingWithPage(page - 1, pageSize)
            .then(({data}) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    };

    const handlers = {
        updater() {
            getNonShippingsData(1, 10);
        },
        modalCloser() {
            // setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map(outgoing => ({
                    key: outgoing.id,
                    id: outgoing.id,
                    stockCode: outgoing.sn,
                    customer: outgoing.cn,
                    outgoingQuantity: outgoing.oq,
                    outgoingType: outgoing.ot,
                    status: outgoing.os,
                    creater: outgoing.e,
                    createdDate: outgoing.cd,
                    consignmentStatus: outgoing.cc
            }))
            setSortedList(sorted)
        }
    }

    const columns = [
        {
            title: 'İşlem Tarihi',
            key: 'createdDate',
            render: (text, record) => userDateFormatter(record.createdDate)
        },
        {
            title: 'Ürün',
            dataIndex: 'stockCode',
            key: 'stockCode'
        },
        {
            title: 'Müşteri',
            dataIndex: 'customer',
            key: 'customer'
        },
        {
            title: 'Çıkış Miktarı',
            dataIndex: 'outgoingQuantity',
            key: 'outgoingQuantity'
        },
        {
            title: 'İşlemi Yapan',
            dataIndex: 'creater',
            key: 'creater'
        },
        {
            title: 'Çıkış Tipi',
            key: 'tags',
            render: (text, record) => <TagsType record={record.outgoingType} />
        },
        {
            title: 'İşlem Durumu',
            key: 'status',
            render: (text, r) => <TagsStatus record={r.status} />
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (t, r) => r.outgoingType === 'CONSIGNED' ?
                <OutgoingActions
                    isConsignmentCompleted={r.consignmentStatus}
                    recordId={r.id}
                    updater={handlers.updater}
                /> : null
        }
    ]

    return (
        <React.Fragment>
            <Table
                scroll={{ x: 'max-content' }}
                columns={columns}
                dataSource={sortedList}
                pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                }}
            />
        </React.Fragment>
    )
}
export default OutgoingTab